<template>
    <v-btn @click="generate()" class="get-code-cls amber lighten-1">Get Code</v-btn> 
</template>

<script>
export default {
  name: 'BannerCodeGenerator',
  methods: {
    generate () {
      this.$emit('generated', Math.random().toString(36).substr(2, 10))
    }
  }
}
</script>
<style scoped>
</style>